import type {LevelGeometryDocument} from "@/dungeons/model/DungeonGeometry.ts";

const MAX_HISTORY_ENTRIES = 100;

export type DungeonEditorHistoryEntry = {
    levelId: string;
    before: LevelGeometryDocument;
    after: LevelGeometryDocument;
};

export type DungeonEditorHistoryState = {
    undoStack: DungeonEditorHistoryEntry[];
    redoStack: DungeonEditorHistoryEntry[];
};

export type DungeonEditorHistoryAction =
    | {type: "RECORD"; entry: DungeonEditorHistoryEntry}
    | {type: "UNDO"}
    | {type: "REDO"}
    | {type: "CLEAR"};

export const initialDungeonEditorHistoryState: DungeonEditorHistoryState = {
    undoStack: [],
    redoStack: [],
};

export const dungeonEditorHistoryReducer = (
    state: DungeonEditorHistoryState,
    action: DungeonEditorHistoryAction,
): DungeonEditorHistoryState => {
    switch (action.type) {
        case "RECORD":
            return {
                undoStack: [...state.undoStack, action.entry].slice(-MAX_HISTORY_ENTRIES),
                redoStack: [],
            };
        case "UNDO": {
            const entry = state.undoStack[state.undoStack.length - 1];
            if (!entry) return state;
            return {
                undoStack: state.undoStack.slice(0, -1),
                redoStack: [...state.redoStack, entry],
            };
        }
        case "REDO": {
            const entry = state.redoStack[state.redoStack.length - 1];
            if (!entry) return state;
            return {
                undoStack: [...state.undoStack, entry].slice(-MAX_HISTORY_ENTRIES),
                redoStack: state.redoStack.slice(0, -1),
            };
        }
        case "CLEAR":
            return initialDungeonEditorHistoryState;
    }
};
